// extracted by mini-css-extract-plugin
export default {"documentsList":"DocumentsList_documentsList__Y89I5"};